import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetProjectCostSummaryQuery } from "../../../services/Reports";
import {
  getProjectCostSummaryRequest,
  getProjectCostSummaryFailure,
  getProjectCostSummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allProjectCostSummary,
    isLoading: projectCostSummaryLoading,
    isError: projectCostSummaryError,
  } = useGetProjectCostSummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.projectCostSummaryPageNo,
    pageSize: state.projectCostSummaryPageSize,
    fromDate: new Date(state.projectCostSummaryFromDate).toLocaleDateString(),
    toDate: new Date(state.projectCostSummaryToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (projectCostSummaryLoading) {
      dispatch(getProjectCostSummaryRequest());
    }
    if (projectCostSummaryError) {
      dispatch(getProjectCostSummaryFailure(projectCostSummaryError));
    }
    if (allProjectCostSummary) {
      dispatch(
        getProjectCostSummarySuccess({
          data: allProjectCostSummary.data.projectCostSummary[0].data || [],
          totalPages:
            allProjectCostSummary.data.projectCostSummary[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allProjectCostSummary,
    profileData,
    state.projectCostSummaryFromDate,
    state.projectCostSummaryToDate,
    state.projectCostSummaryPageNo,
    state.projectCostSummaryPageSize,
  ]);
  return <></>;
};
export default Content;
